<template>
  <div>
    <div class="vg-content">
      <div class="head" v-if="isSuccess !== undefined">
        <van-image width="40" height="40" :src="isSuccess?srcSuccess:srcFailed"/>
        <div class="result" :style="isSuccess?'color:#4BA9F6':'color:#DC3C27'">{{ strResult }}</div>
      </div>
      <vg-card v-if="isSuccess !== undefined && isError" class="error">{{ errorMessage }}</vg-card>
      <vg-card v-if="isSuccess !== undefined && !isError" class="status"
               :class="{success: isSuccess, failure: !isSuccess}">
        <vg-view-field-list class="no-hr">
          <dp-application-view-field
              v-for="(field, index) in sortedFields"
              :key="field.applicationAttributeFieldId"
              :value="field"
              label-width="120px"
              :bold-value="index < 2"
              label-suffix="："
          />
          <dp-application-view-field
              v-if="this.passCardType === 'TENANT_EMPLOYEE'"
              :value="{attributeName: '有效期至', value: expireTimeFilter(this.expireTime) }"
              label-width="120px"
              label-suffix="："
          />
<!--          <dp-application-view-field-->
<!--              v-if="this.verifyResult !== 'PASS'"-->
<!--              :value="{attributeName: '失败原因', value: verifyResult }"-->
<!--              label-width="120px"-->
<!--              label-suffix="："-->
<!--          />-->
        </vg-view-field-list>
      </vg-card>
    </div>

    <vg-button-group>
      <vg-button type="primary" @click="onSubmit">继续验真</vg-button>
    </vg-button-group>
  </div>
</template>

<script>
import VgButton from "@/components/Commons/VgButton";
import VgButtonGroup from "@/components/Commons/VgButtonGroupFixed.vue";
import {Image as VanImage} from "vant";
import srcSuccess from "@/assets/scanverify/success.svg";
import srcFailed from "@/assets/scanverify/failed.svg";
import srcPass from "@/assets/scanverify/pass.png";
import srcExpired from "@/assets/scanverify/expired.png";
import {client} from "@/libraries/http";
import VgCard from "@/components/Commons/VgCard.vue";
import VgViewFieldList from "@/components/Commons/VgViewFieldList.vue";
import DpApplicationViewField
  from "@/views/DigitalPassApplications/DigitalPassApplication/DpApplicationViewField/index.vue";
import verifyResultMessage from "@/filters/verifyResultMessage";
import expireTime from "@/filters/expireTime";

export default {
  name: "VerifyResult",
  components: {
    DpApplicationViewField,
    VgViewFieldList,
    VgCard,
    VgButton, VgButtonGroup, VanImage,
  },
  data() {
    return {
      srcSuccess: srcSuccess,
      srcFailed: srcFailed,
      srcPass: srcPass,
      srcExpired: srcExpired,

      isSuccess: undefined,
      strResult: "验真成功",
      isError: false,
      errorMessage: "",
      id: "",
      message: undefined,

      passCardApplicationResourceFieldList: undefined,
      expireTime: undefined,
      passCardType: undefined,

      verifyResult: null
    }
  },
  mounted() {
    console.log(this.$route);
    this.id = this.$route.query.id;
    this.message = this.$route.query.message;
    if (this.message) {
      this.isError = true;
      this.errorMessage = this.message;
      this.isSuccess = false;
      this.strResult = "验真失败";
    } else {
      this.detail();
    }
  },
  computed: {
    verifyResultMessage() {
      return verifyResultMessage(this.verifyResult)
    },
    sortedFields() {
      const fields = this.passCardApplicationResourceFieldList || [];
      const orderMap = {
        'PERSONAL_NAME': 1,
        'CONSTRUCTION_LOCATION': 2,
        'TENANT_COMPANY': 3,
        'BRAND': 4,
        'PHONE_NUMBER': 5,
        'PERSONAL_PHOTO': 6,
        'PROJECT_ID': 7,
        'CONSTRUCTION_TYPE': 8,
        'CONSTRUCTOR': 9,
        'CONSTRUCTION_CONTENT': 10,
        'CONSTRUCTION_START_TIME': 11,
        'CONSTRUCTION_END_TIME': 12,
        // 'ID_CARD_PHOTO_FRONT': 12,
        // 'ID_CARD_PHOTO_BACK': 13,
        // 'TP_OVERTIME_APPROVAL_PHOTO': 14,
      }

      return fields.filter(field => orderMap[field.attributeType])
          .sort((l, r) => {
            return orderMap[l.attributeType] - orderMap[r.attributeType]
          })
    }
  },
  methods: {
    onSubmit() {
      this.$router.replace({path: '/scanVerify/richScan'});
    },
    expireTimeFilter(value) {
      return expireTime(value)
    },
    detail() {
      client.get("/api/h5/guard/verify/detail/" + this.id).then(res => {
        console.log(res);
        this.isSuccess = res.data.verifyResult === "PASS";
        this.strResult = this.isSuccess ? "验真成功" : "验真失败";
        this.verifyResult = res.data.verifyResult;
        if (res.data.verifyResult === 'QR_EXPIRED') {
          this.isError = true;
          this.errorMessage = "无效二维码，电子出入证二维码已过期，请刷新电子出入证二维码";
        } else if (res.data.verifyResult === 'DIFF_PROJECT') {
          this.isError = true;
          this.errorMessage = "无效二维码，电子出入证二维码所属项目与当前扫码验真项目不一致，请切换项目后重试";
        } else {
          this.isError = false;
          this.passCardApplicationResourceFieldList = res.data.passCardApplicationResourceFieldList;
          this.expireTime = res.data.expireTime;
          this.passCardType = res.data.passCardType;
        }
      }).catch(error => {
        console.log(error);
        this.isError = true;
        this.errorMessage = error.response.data?.message;
        this.isSuccess = false;
        this.strResult = "验真失败";
      })
    },
  },
}
</script>

<style scoped>
.vg-content {
  /*margin: 15px;*/
  display: flex;
  flex-direction: column;
}

.head {
  margin-top: 20px;
  display: flex;
  align-items: center;
  align-self: center;
}

.result {
  margin-left: 15px;
  font-size: 26px;
  color: #4BA9F6;
}


.item {
  position: relative;
  margin-top: 30px;
  width: auto;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
}

.item-entry {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 80px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #000000;
}

.status:before {
  content: "";
  opacity: 0.7;
  position: absolute;
  right: 10px;
  bottom: 70px;
  width: 22vw;
  height: 16.5vw;
  background-size: contain;
  background-repeat: no-repeat;
}

.status.success:before {
  background-image: url("@/assets/scanverify/pass.png");
}

.status.failure:before {
  background-image: url("@/assets/scanverify/expired.png");
}

.error {
  margin-top: 30px;
  width: auto;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  color: #101010;
  font-size: 16px;
  text-align: left;
}

</style>
